import type { Patient } from '../../../types/types';
import type { PatientInfoResponse } from '../store/api';

/**
 * Derive the flat `Patient` shape (used by legacy patient-facing components)
 * from the nested `PatientInfoResponse` returned by `usePatientInfoQuery`.
 *
 * Mirrors the inline derivation in `EncounterViewV2` so surfaces reading
 * patient demographics off RTK Query stay consistent. `patient_id` is taken
 * from the caller since the query is keyed by it.
 */
export function mapPatientInfoResponseToPatient(
  response: PatientInfoResponse,
  patientId: string,
): Patient {
  const { demographics, contact } = response;

  return {
    patient_id: patientId,
    first_name: demographics.first_name ?? undefined,
    last_name: demographics.last_name ?? undefined,
    preferred_name: demographics.preferred_name ?? undefined,
    middle_name: demographics.middle_name ?? undefined,
    dob: demographics.dob ?? null,
    gender: demographics.gender ?? undefined,
    pronouns: demographics.pronouns ?? undefined,
    email: contact.email ?? undefined,
    mobile_phone: contact.mobile_phone ?? null,
    phone: contact.mobile_phone ?? undefined, // Fallback field for phone lookups
  } as Patient;
}
